import moment from 'moment'

const initialState = {
  loading: false,
  loaded: false,
  stepCompleted: false,
  time: moment(),
  date: moment()
}

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }
    case 'SET_TIME': {
      return {
        ...state,
        time: action.payload.time,
        date: action.payload.date,
        stepCompleted: true,
      }
    }

    default: {
      return state
    }
  }
}
